/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBubbleText = createReactComponent("outline", "bubble-text", "IconBubbleText", [["path", { "d": "M7 10h10", "key": "svg-0" }], ["path", { "d": "M9 14h5", "key": "svg-1" }], ["path", { "d": "M12.4 3a5.34 5.34 0 0 1 4.906 3.239a5.333 5.333 0 0 1 -1.195 10.6a4.26 4.26 0 0 1 -5.28 1.863l-3.831 2.298v-3.134a2.668 2.668 0 0 1 -1.795 -3.773a4.8 4.8 0 0 1 2.908 -8.933a5.33 5.33 0 0 1 4.287 -2.16", "key": "svg-2" }]]);

export { IconBubbleText as default };
//# sourceMappingURL=IconBubbleText.mjs.map
